import React from "react";
import { SketchPicker } from "react-color";

import styled from "styled-components";
import { IColorElem } from "../../rule-engine-core/Common/IColorElem";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";
import { Box, TextField } from "@mui/material";
import { UIStandardLayer } from "../BuildlingBlocks/UIStandardLayer";
import { ValidationIssue } from "../../rule-engine-core/Common/IDesignValidationProvider";

export interface IColorPickerDialog {
    position: {
        x: number;
        y: number;
    };
    instance: IColorElem;
}

export interface IColorElemContext {
    selectedForColor: IColorPickerDialog | undefined;
}

interface IColorPicker {
    value?: string | undefined;
    open: boolean;
    position?: {
        x: number;
        y: number;
    };
    onChange: (color: string) => void;
    onClose: () => void;
}

export const ColorPicker: React.FC<IColorPicker> = (props: IColorPicker) => {
    const [color, setColor] = React.useState<string | undefined>(props.value);
    const onChange = (data: any) => {
        setColor(data.hex);
    };

    return (
        <UIStandardLayer
            onClose={props.onClose}
            validationIssues={!color ? [new ValidationIssue("Please Select Color")] : []}
            renderUI={() => {
                return (
                    <Box
                        width={"270px"}
                        display={"flex"}
                        flexDirection={"column"}
                        data-testid="ColorPickerLayer-root"
                    >
                        <SketchPicker
                            onChange={onChange}
                            color={color || ""}
                            data-testid={`ColorPickerDialog-root`}
                        />
                        <StyledTextField
                            variant="outlined"
                            size={"small"}
                            value={color}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                setColor(event.target.value);
                            }}
                            InputProps={{
                                endAdornment: (
                                    <Box
                                        bgcolor={color}
                                        width={"20px"}
                                        height={"20px"}
                                        border={"1px solid " + UIStyleConstants.GRAY_DARK_COLOR}
                                    ></Box>
                                ),
                            }}
                            data-testid="ColorPickerLayer-colorInput"
                        />
                    </Box>
                );
            }}
            open={props.open}
            primaryActionText={"Select"}
            onPrimaryAction={() => {
                if (color) props.onChange(color);
            }}
            secondaryActionText={"Cancel"}
            onSecondaryAction={props.onClose}
            title={"Pick Color"}
        />
    );
};

// function rgb2hsv({ r, g, b }: RGBColor): { h: number; s: number; v: number } {
//     let rr: number,
//         gg: number,
//         bb: number,
//         h: number = 0,
//         s: number = 0;
//     let rabs = r / 255;
//     let gabs = g / 255;
//     let babs = b / 255;
//     let v = Math.max(rabs, gabs, babs);
//     let diff = v - Math.min(rabs, gabs, babs);
//     const diffc = (c: number) => (v - c) / 6 / diff + 1 / 2;
//     const percentRoundFn = (num: number) => Math.round(num * 100) / 100;
//     if (diff === 0) {
//         h = s = 0;
//     } else {
//         s = diff / v;
//         rr = diffc(rabs);
//         gg = diffc(gabs);
//         bb = diffc(babs);

//         if (rabs === v) {
//             h = bb - gg;
//         } else if (gabs === v) {
//             h = 1 / 3 + rr - bb;
//         } else if (babs === v) {
//             h = 2 / 3 + gg - rr;
//         }
//         if (h < 0) {
//             h += 1;
//         } else if (h > 1) {
//             h -= 1;
//         }
//     }
//     return {
//         h: Math.round(h * 360),
//         s: percentRoundFn(s * 100),
//         v: percentRoundFn(v * 100),
//     };
// }

// function rgbToHsl(props: RGBColor): HSLColor {
//     let r: number = props.r / 255,
//         g: number = props.g / 255,
//         b: number = props.b / 255;
//     let max: number = Math.max(r, g, b),
//         min: number = Math.min(r, g, b);
//     let h: number = (max + min) / 2,
//         s: number = (max + min) / 2,
//         l: number = (max + min) / 2;

//     if (max === min) {
//         h = s = 0;
//     } else {
//         let d = max - min;
//         s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
//         switch (max) {
//             case r:
//                 h = (g - b) / d + (g < b ? 6 : 0);
//                 break;
//             case g:
//                 h = (b - r) / d + 2;
//                 break;
//             case b:
//                 h = (r - g) / d + 4;
//                 break;
//         }
//         h /= 6;
//     }

//     return { h, s, l };
// }

// const CustomColorPicker = CustomPicker(({ hsl, rgb, onChange }) => {
//     return (
//         <>
//             {onChange && (
//                 <Box
//                     sx={{
//                         width: "272px",
//                         height: "190px",
//                         position: "relative",
//                     }}
//                 >
//                     <Saturation
//                         hsl={hsl || rgbToHsl(rgb || { r: 0, g: 0, b: 0 })}
//                         hsv={rgb2hsv(rgb || { r: 0, g: 0, b: 0 })}
//                         onChange={onChange}
//                     />
//                 </Box>
//             )}
//             <Box padding={"8px 16px"}>
//                 {onChange && (
//                     <StyledHueRender>
//                         <Hue
//                             hsl={hsl || rgbToHsl(rgb || { r: 0, g: 0, b: 0 })}
//                             onChange={onChange}
//                         />
//                     </StyledHueRender>
//                 )}
//             </Box>
//         </>
//     );
// });

// const StyledHueRender = styled.div`
//     height: 24px;
//     position: relative;

//     > div {
//         padding: 8px 0;

//         .hue-horizontal {
//             border-radius: 8px;

//             > div > div {
//                 margin-top: 0 !important;
//                 background: ${UIStyleConstants.BLUE_COLOR} !important;
//                 transform: translateX(-12px) translateY(-8px) !important;
//                 width: 24px !important;
//                 height: 24px !important;
//                 box-shadow: 0px 2px 4px ${UIStyleConstants.GRAY_LIGHTER_COLOR} !important;
//                 border-radius: 50% !important;
//                 border: solid 2px ${UIStyleConstants.WHITE_COLOR};
//             }
//         }
//     }
// `;

const StyledTextField = styled(TextField)`
    &.MuiTextField-root input {
        background: ${UIStyleConstants.GRAY_LIGHT_COLOR} !important;

        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;

        color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
    }

    &.MuiTextField-root .MuiOutlinedInput-notchedOutline {
        border: 1px solid ${UIStyleConstants.GRAY_LIGHTER_COLOR};
        box-sizing: border-box;
        border-radius: 4px;
    }

    .MuiInputAdornment-root .MuiTypography-body1 {
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 17px;
        letter-spacing: 0px;
        text-align: center;

        color: ${UIStyleConstants.GRAY_LIGHT_COLOR};
    }
`;
